import { HeapPHIDecorator } from "@app/components/analytics";
import React, { FC, useEffect, useState } from "react";
import { defineMessages, useIntl } from "react-intl";
import { PhoneField as BasePhoneField } from "@natera/form";
import { GetValidationError } from "@natera/platform/lib/hooks/useError";
import { FormField } from "@app/components";

const messages = defineMessages({
  phoneFieldTitle: {
    id: "phoneFieldTitle",
    defaultMessage: "Mobile Number",
  },
  phoneFieldTooltip: {
    id: "phoneFieldTooltip",
    defaultMessage: "10 or 11 digit number",
  },
  phoneFieldPlaceholder: {
    id: "phoneFieldPlaceholder",
    defaultMessage: "(xxx) xxx-xxxx",
  },
});

interface PhoneFieldProps {
  currentPhone?: string;
  getValidationError: GetValidationError;
  withPadding?: boolean;
  required?: boolean;
  onPhoneValueChange?: (phone: string) => void;
  disabled?: boolean;
}

const PhoneField: FC<PhoneFieldProps> = ({
  currentPhone,
  getValidationError,
  withPadding = false,
  required = true,
  onPhoneValueChange,
  disabled = false,
}) => {
  const intl = useIntl();
  const [mobileNumberField, setMobileNumberField] = useState("");

  useEffect(() => {
    currentPhone && setMobileNumberField(currentPhone);
  }, [currentPhone]);

  const handleMobileNumberFieldChange = (phone: string) => {
    setMobileNumberField(phone);
    onPhoneValueChange?.(phone);
  };

  return (
    <>
      <div id="mobileNumber-instructions" className="visually-hidden">
        {intl.formatMessage(messages.phoneFieldTooltip)}
      </div>
      <FormField
        label={intl.formatMessage(messages.phoneFieldTitle)}
        required={required}
        error={getValidationError("mobileNumber")}
        htmlFor="mobile"
        withPadding={withPadding}
      >
        <HeapPHIDecorator protectAttr={["value"]} noWrap>
          <BasePhoneField
            id="mobile"
            name="mobileNumber"
            data-testid="mobileNumberId"
            placeholder={intl.formatMessage(messages.phoneFieldPlaceholder)}
            value={mobileNumberField}
            onPhoneChange={handleMobileNumberFieldChange}
            autoComplete="tel"
            required
            outline
            aria-describedby={
              getValidationError("mobileNumber")
                ? "mobileNumber-instructions mobileNumber-error"
                : "mobileNumber-instructions"
            }
            disabled={disabled}
          />
        </HeapPHIDecorator>
      </FormField>
    </>
  );
};

export default PhoneField;
